import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { TimerLoaderContent, TimerLoaderWrapper, Text } from './styles';
export const TimerLoader = () => {
    const { colors } = useTheme();
    return (_jsx(TimerLoaderWrapper, { children: _jsx(TimerLoaderContent, { backgroundColor: colors.surface.interactiveDefault, foregroundColor: colors.surface.pressed, children: _jsx(Text, {}) }) }));
};
//# sourceMappingURL=TimerLoader.js.map